import React, { PropTypes, PureComponent } from 'react';
import moment from 'moment-timezone';
import _ from 'underscore';
import { Table, Tip } from 'react-fast-ui';
import cx from 'classnames';
import { isGameComplete } from '../../util/EventUtil';
import standardIcons from '../../util/constants/icons';
import IconButton from '../../components/layout/IconButton';
import { getTableSortProps } from '../../util/Etc';

const Score = ({ score: { score, notes } }) => (
  notes ?
    (
      <Tip tip={notes}>
        <strong>{score}</strong>
      </Tip>
    ) :
    <strong>{score}</strong>
);

const Side = ({ tourneyId, side: { team, score, seed }, onClickTeam, winner = false }) => (
  <div
    className={cx('display-flex align-items-center mg-right-sm', { 'bg-color-success color-white': winner })}
    style={{ border: '1px solid' }}>
    <div className="flex-grow-1 pd-sm">
      {!team && seed && <div>{seed.displayName}</div>}
      {
        team && !seed &&
        <strong className="display-flex justify-content-space-between">
          {team.name}
          <IconButton
            className="mg-left-sm"
            iconSize="sm"
            icon={standardIcons.share}
            onClick={() => onClickTeam(team)}
          />
        </strong>
      }
      {
        team && seed &&
        <Tip tip={seed.displayName} className="display-flex justify-content-space-between">
          <strong><em>{team.name}</em></strong>
          <IconButton
            className="mg-left-sm"
            iconSize="sm"
            icon={standardIcons.share}
            onClick={() => onClickTeam(team)}
          />
        </Tip>
      }
    </div>
    {
      score &&
      <div className="flex-shrink-0 mg-left-sm pd-sm" style={{ borderLeft: '1px solid' }}>
        <Score score={score}/>
      </div>
    }
  </div>
);

const CANCELLED_STYLE = {
  textDecoration: 'line-through',
  color: 'red'
};

class GameRow extends PureComponent {
  static propTypes = {
    game: PropTypes.shape({}).isRequired,
    buttonComponent: PropTypes.func,
    onClickTeam: PropTypes.func.isRequired,
  };

  render() {
    const { game, buttonComponent: ButtonComponent, onClickTeam, ...rest } = this.props;

    const {
      id, name, scheduled, cancelled,
      court,
      gameGroup: { type, name: groupName, division: { name: divisionName, tourney: { id: tourneyId, timezone } } },
      ignoreStandings,
      sides: { home, visitor },
    } = game;

    const complete = isGameComplete(game);

    let winner = null;
    if (complete && home.score.score !== visitor.score.score) {
      winner = home.score.score > visitor.score.score ? 'home' : 'visitor';
    }

    return (
      <Table.tr {...rest}>
        <Table.td>
          <span style={cancelled ? CANCELLED_STYLE : null} title={id}>
            {moment.tz(scheduled, timezone).format('M/D/YY LT z')}
          </span>
        </Table.td>
        <Table.td><strong style={{ wordBreak: 'break-all' }}>{name}</strong></Table.td>
        <Table.td className={cx({ 'color-danger': !court })}>
          <div className="hidden-sm hidden-xs">{court ? court.venue.name : 'N/A'}</div>
          <div className="visible-sm visible-xs">{court ? court.venue.nickname : 'N/A'}</div>
        </Table.td>
        <Table.td className={cx({ 'color-danger': !court })}>
          {court ? court.name : 'N/A'}
        </Table.td>
        <Table.td className="hidden-xs">
          <div><em>{type}</em></div>
          <div>{groupName}</div>
        </Table.td>
        <Table.td className="hidden-xs">
          {divisionName}
        </Table.td>
        <Table.td>
          {home && <Side tourneyId={tourneyId} winner={winner === 'home'} side={home} onClickTeam={onClickTeam}/>}
        </Table.td>
        <Table.td>
          {
            visitor &&
            <Side tourneyId={tourneyId} winner={winner === 'visitor'} side={visitor} onClickTeam={onClickTeam}/>
          }
        </Table.td>
        <Table.td>
          {ButtonComponent ? <ButtonComponent game={game}/> : null}
        </Table.td>
      </Table.tr>
    );
  }
}

export default class AdminGameTable extends PureComponent {
  static propTypes = {
    games: PropTypes.arrayOf(PropTypes.object).isRequired,
    querySort: PropTypes.string,
    onSort: PropTypes.func.isRequired,
    buttonComponent: PropTypes.func,
    onClickTeam: PropTypes.func.isRequired,
  };

  static defaultProps = {
    buttonComponent: null
  };

  render() {
    const { games, querySort, onSort, buttonComponent, onClickTeam, ...rest } = this.props;

    const sa = attribute => getTableSortProps({ attribute, querySort, handler: onSort });

    return (
      <Table {...rest}>
        <Table.thead>
          <Table.th {...sa('scheduled')}>Time</Table.th>
          <Table.th>Name</Table.th>
          <Table.th>Venue</Table.th>
          <Table.th>Court</Table.th>
          <Table.th className="hidden-xs">Group</Table.th>
          <Table.th className="hidden-xs">Division</Table.th>
          <Table.th>Home</Table.th>
          <Table.th>Visitor</Table.th>
          <Table.th/>
        </Table.thead>
        <Table.tbody>
          {
            _.map(
              games,
              game => <GameRow key={game.id} game={game} buttonComponent={buttonComponent} onClickTeam={onClickTeam}/>
            )
          }
        </Table.tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/GameDay/components/AdminGameTable.jsx